import React, { FunctionComponent, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { BlogArticleList } from '../components/blog-article-list'
import { BlogSection } from '../components/blog-section'
import { Mbr } from '../components/br'
import { CompactNewsList } from '../components/compact-news-list'
import { ContentContainer } from '../components/content-container'
import { HeadBannar } from '../components/head-bannar'
import { Section } from '../components/section'
import { SectionTitle } from '../components/section-title'
import { Title } from '../components/title'
import { TopBanner } from '../components/top-banner'
import { useInstaPageQueryQuery } from '../generated/graphql'
import { useBreakpoint } from '../hooks/use-breakpoint'

const Outer = styled.div``

const NewsListContainer = styled.div`
  width: 50rem;
  max-width: 100vw;
  padding: 4rem 2rem;
  box-sizing: border-box;
`

const BlogArticleListContainer = styled.div`
  width: 80rem;
  max-width: 100vw;
  padding: 4rem 2rem;
  box-sizing: border-box;

`

const MapContainer = styled.div`
  width: 80rem;
  max-width: 100vw;
  padding: 4rem 2rem;
  box-sizing: border-box;
  @media (max-width: 40rem){
    padding-left: 0;
    padding-right: 0;
  }
  iframe {
    width: 100%;
  }
`

const InstagramContainer = styled.div`
  width: 80rem;
  max-width: 100vw;
  padding: 4rem 2rem 2rem;
  box-sizing: border-box;
  @media (max-width: 40rem){
    padding-left: 0;
    padding-right: 0;
  }
  #sb_instagram {
    padding: 0 !important;
  }
  #sbi_images {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(4, 1fr);
    padding: 0 !important;
  }
  a {
    display: block;
  }
  img {
    aspect-ratio: 1 / 1;
    object-fit: cover;
    width: 100%;
    height: auto;
    display: block;
  }

  .svg-inline--fa,
  .sbi-screenreader {
    display: none;
  }
`

const FollowUs = styled.a`
  text-decoration: underline;
`

type TopPageProps = {

}
export const TopPage: FunctionComponent<TopPageProps> = () => {
  const isMobile = useBreakpoint('40rem')
  const instaPageQuery = useInstaPageQueryQuery()
  const instagramContainerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    if(instaPageQuery.loading) return
    const container = instagramContainerRef.current
    if(container){
      const items = container.querySelectorAll('a')
      items.forEach(item => {
        const json = item.dataset['imgSrcSet']
        if(json){
          const srcSet = JSON.parse(json)
          const img = item.querySelector('img')
          if(img) {
            img.src = srcSet.d
          }
          
        }
      })
    }
  }, [instaPageQuery.loading])
  return <Outer>
    <HeadBannar desktop={() => <TopBanner />} mobile={() => <TopBanner />}></HeadBannar>
    <ContentContainer>
      <Title>日本の未来を<Mbr />デザインする<br />幼児教育・保育施設</Title>
      <Section>
        <SectionTitle>新着情報</SectionTitle>
        <NewsListContainer>
          <CompactNewsList />
        </NewsListContainer>
      </Section>
      <BlogSection count={isMobile ? 3 : 8} showMobile/>
      {/* <Section>
        <SectionTitle>Instagram</SectionTitle>
        <InstagramContainer
          ref={instagramContainerRef}
          dangerouslySetInnerHTML={{__html: instaPageQuery.data?.pageBy?.content ?? ''}}
        />
        <FollowUs href="https://www.instagram.com/muronoki.kg/">Follow us</FollowUs>
      </Section> */}
      <Section>
        <SectionTitle>アクセス</SectionTitle>
        <MapContainer>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3252.1365886306016!2d139.57967916620856!3d35.401864780260425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185b3a5dea6fed%3A0xbbc6d128c6103387!2z6KqN5a6a44GT44Gp44KC5ZySIOODoOODreODjuOCreODg-OCug!5e0!3m2!1sen!2sjp!4v1643703720551!5m2!1sen!2sjp" width="600" height="450" allowFullScreen loading="lazy"></iframe>
        </MapContainer>
      </Section>
    </ContentContainer>
  </Outer>
}